(function(){
if(window.__hvb) return; window.__hvb=1;
function init(){
var $=function(id){return document.getElementById(id)};
var cfg=$('hvbCfg'), openOnSelect=!cfg||cfg.getAttribute('data-open')!=='false';
var fmt=function(n){n=Number(n);return 'Q'+(n%1? n.toFixed(2): n.toString());};
var on=document.querySelector('.hvb .tiers .tier.on')||document.querySelector('.hvb .tiers .tier');
var state=on?{price:on.dataset.price,comp:on.dataset.comp,save:on.dataset.save,qty:+on.dataset.qty}:{price:'379.99',comp:'597',save:'217',qty:3};

function paint(){
  var p=fmt(state.price);
  ['hPrice','bPrice','b2Price','sPrice'].forEach(function(id){var e=$(id); if(e) e.textContent=p;});
  var hc=$('hComp'), bc=$('bComp'), hs=$('hSave');
  if(hc&&bc&&hs){
    if(state.comp){hc.textContent=fmt(state.comp);hc.style.display='';bc.textContent=fmt(state.comp);bc.style.display='';hs.textContent='Ahorrás '+fmt(state.save);hs.style.display='';}
    else{hc.style.display='none';bc.style.display='none';hs.style.display='none';}
  }
  var g=$('giftIt'); if(g) g.classList.toggle('lock', state.qty<3);
  document.querySelectorAll('.hvb .tiers').forEach(function(list){
    list.querySelectorAll('.tier').forEach(function(t){var o=t.dataset.qty==String(state.qty); t.classList.toggle('on',o); var i=t.querySelector('input'); if(i) i.checked=o;});
  });
}

/* ---- Kaching + Releasit ---- */
var IDX={5:0,3:1,1:2};
function kSelect(q){
  var bars=[].slice.call(document.querySelectorAll('.kaching-bundles__bar'));
  if(!bars.length) return false;
  var re=q>1?new RegExp('Lleva\\s*'+q+'\\b','i'):/Compra\s*1\b|\b1\s*Frasco/i;
  var tg=bars.filter(function(b){return re.test(b.innerText);})[0]||bars[IDX[q]];
  if(tg&&!tg.classList.contains('kaching-bundles__bar--selected')){var inp=tg.querySelector('input'); if(inp) inp.click(); else tg.click();}
  return true;
}
var RIDX={5:0,3:1,1:2};
function syncForm(n){
  var r=document.querySelector('.rsi-form-wrapper-dialog input[value="quantity_'+RIDX[state.qty]+'"]');
  if(r){r.click();if(n<6) setTimeout(function(){syncForm(n+1);},120);return;}
  if(n<40) setTimeout(function(){syncForm(n+1);},50);
}
function openForm(tries){
  tries=tries||0;
  var b=document.querySelector('#ctaMain button#rsi_buy_now_button')||document.querySelector('button#rsi_buy_now_button')||document.querySelector('#ctaMain button');
  if(b){b.click();syncForm(0);return;}
  if(tries<80) setTimeout(function(){openForm(tries+1);},60);
  else {var o=$('tiers1'); if(o) window.scrollTo({top:o.getBoundingClientRect().top+scrollY-90,behavior:'smooth'});}
}
function choose(q,open,tries){
  tries=tries||0;
  if(!kSelect(q)&&tries<80){setTimeout(function(){choose(q,open,tries+1);},60);return;}
  if(open) openForm();
}
var last=0;
document.querySelectorAll('.hvb .tiers .tier').forEach(function(t){
  t.addEventListener('click',function(e){
    e.preventDefault();
    state={price:t.dataset.price,comp:t.dataset.comp,save:t.dataset.save,qty:+t.dataset.qty}; paint();
    var n=Date.now(); if(n-last<250) return; last=n;
    choose(state.qty,openOnSelect);
  });
});
document.querySelectorAll('.hvb [data-cta]').forEach(function(b){
  b.addEventListener('click',function(e){e.preventDefault(); var n=Date.now(); if(n-last<250) return; last=n; choose(state.qty,true);});
});
choose(state.qty,false); /* deja Kaching/Releasit con el mismo pack que se ve en pantalla */

/* ---- Galería + zoom ---- */
var main=$('mainImg'), lb=$('lb');
document.querySelectorAll('#thumbs img').forEach(function(im){
  im.addEventListener('click',function(){ if(main) main.src=im.dataset.full; document.querySelectorAll('#thumbs img').forEach(function(x){x.classList.remove('on')}); im.classList.add('on');});
});
if(main&&lb){
  main.addEventListener('click',function(){lb.querySelector('img').src=main.src;lb.classList.add('show');});
  lb.addEventListener('click',function(){lb.classList.remove('show');});
}

/* ---- Carruseles con puntos ---- */
document.querySelectorAll('.hvb [data-car]').forEach(function(car){
  var dots=car.nextElementSibling; if(!dots||!dots.hasAttribute('data-dots')||!car.children.length) return;
  for(var i=0;i<car.children.length;i++){var d=document.createElement('i'); if(!i) d.className='on'; dots.appendChild(d);}
  car.addEventListener('scroll',function(){var w=car.children[0].offsetWidth+14; var k=Math.round(car.scrollLeft/w); dots.querySelectorAll('i').forEach(function(d,j){d.classList.toggle('on',j===k);});},{passive:true});
});

/* ---- Contadores ---- */
var counted=false, st=document.querySelector('.hvb .stats');
function runCounters(){
  document.querySelectorAll('.hvb [data-count]').forEach(function(el){
    var to=+el.getAttribute('data-count'), pre=el.getAttribute('data-prefix')||'', t0=performance.now();
    (function step(t){var k=Math.min(1,(t-t0)/1200); el.textContent=pre+Math.round(to*k).toLocaleString('en-US'); if(k<1) requestAnimationFrame(step);})(t0);
  });
}
if(st&&'IntersectionObserver' in window){
  new IntersectionObserver(function(es,o){es.forEach(function(e){if(e.isIntersecting&&!counted){counted=true;runCounters();o.disconnect();}});},{threshold:.3}).observe(st);
}else{document.querySelectorAll('.hvb [data-count]').forEach(function(el){el.textContent=(el.getAttribute('data-prefix')||'')+(+el.getAttribute('data-count')).toLocaleString('en-US');});}

/* ---- Botón fijo ---- */
var bar=$('sticky'), anchor=$('trustAnchor'), offers=[$('tiers1'),$('tiers2')].filter(Boolean);
function tick(){
  if(!bar) return;
  var past=anchor?anchor.getBoundingClientRect().bottom<0:scrollY>600;
  var vis=offers.some(function(o){var r=o.getBoundingClientRect();return r.top<innerHeight&&r.bottom>0;});
  var cm=$('ctaMain'), cv=false; if(cm){var r=cm.getBoundingClientRect(); cv=r.top<innerHeight&&r.bottom>0;}
  bar.classList.toggle('show',past&&!vis&&!cv);
}
addEventListener('scroll',tick,{passive:true}); tick();

/* ---- Clarity ---- */
function cset(k,v){try{if(typeof window.clarity==='function')window.clarity('set',k,v);}catch(e){}}
function cev(n){try{if(typeof window.clarity==='function')window.clarity('event',n);}catch(e){}}
cset('lp_variant','resilia_v1');
var lastQty=state.qty;
document.querySelectorAll('.hvb .tiers .tier').forEach(function(t){t.addEventListener('click',function(){var q=+t.dataset.qty; if(q!==lastQty){lastQty=q;cev('offer_select_'+q);cset('offer_qty',String(q));}});});
document.querySelectorAll('.hvb [data-cta]').forEach(function(b){b.addEventListener('click',function(){cev('cta_'+b.dataset.loc);cev('cta_click');});});
document.querySelectorAll('.hvb details').forEach(function(d,i){d.addEventListener('toggle',function(){if(d.open)cev('faq_open_'+(i+1));});});
if(main) main.addEventListener('click',function(){cev('zoom_open');});
if('IntersectionObserver' in window){
  var seen={}, marks={'tiers1':'view_offer','mech':'view_mechanism','ing':'view_ingredients','revs':'view_reviews','tiers2':'view_offer2','faq':'view_faq'};
  var so=new IntersectionObserver(function(es){es.forEach(function(e){var k=marks[e.target.id]; if(e.isIntersecting&&k&&!seen[k]){seen[k]=1;cev(k);}});},{threshold:.4});
  Object.keys(marks).forEach(function(id){var el=$(id); if(el) so.observe(el);});
}
paint();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
